import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { API_JAVA_ALTERA_MAQUINA } from '../app.api';
import { EditarService } from '../services/editar.service';
import { HttpUtilService } from '../services/http-util.service';


@Component({
  selector: 'app-altera-maquina',
  templateUrl: './altera-maquina.component.html',
  styleUrls: ['./altera-maquina.component.css']
})
export class AlteraMaquinaComponent implements OnInit {

  formulario: FormGroup;
  lstEnvios: Object[];
  dataExpiracao: string;
  status;
  ishabilitado = false;
  private chaveMaquina: string;

  constructor(private edicaoService: EditarService,
              private builder: FormBuilder,
              private httpUtil: HttpUtilService,
              private router: Router) { }

  ngOnInit() {
    this.lstEnvios = this.Envios;
    this.criarFormulario();
    this.edicaoService.objectData.subscribe(data => {
      this.dataExpiracao = data.dtFinal;
      this.chaveMaquina = data.chaveMaquina;
      this.formulario.patchValue({'nomeMaquina': data.nomeMaquina});
    }); 
  }

  private Envios: Object[] = [
    { id: '1', name: 'Envio único', value: 0, "checked": false },
    { id: '2', name: 'Envio por 30 dias', value: 30, "checked": false },
    { id: '3', name: 'Envio por 1 ano', value: 365, "checked": false },
    { id: '4', name: 'Envio por tempo indeterminado', value: 36500, "checked": false }
  ];

  private criarFormulario(): void {
    this.formulario = this.builder.group({
      nomeMaquina: [null, Validators.required],
      qtdDiasExpiracao: []
    });
  }

  get nomeMaquina() {
    return this.formulario.get('nomeMaquina');
  }

  async gravar() {
    //limpa mensagem
    this.ishabilitado = true;
    this.httpUtil.put(`${API_JAVA_ALTERA_MAQUINA}/${this.chaveMaquina}`, this.formulario.value)
            .subscribe(() => {
              this.ishabilitado = false;
              this.router.navigate(['/consulta-maquina']);
    });
  }

  
onClose(){
  this.router.navigate(['/consulta-maquina']);
}
}
